import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import BootstrapVue from "bootstrap-vue";
import Croppa from "vue-croppa";
import VueCropper from "vue-cropper";
import auth from "./services/auth";
import moment from "moment";
import VueMomentJS from "vue-momentjs";
import velocity from "velocity-animate";
import Notifications from "vue-notification";
import permission from "./services/user.permission";
import VueTruncate from "vue-truncate-filter";
import VueAnalytics from "vue-analytics";
import * as VueGoogleMaps from "vue2-google-maps";
import Vuelidate from "vuelidate";
// import IdleVue from "idle-vue";

const isSegmentAnalyticsReady = store.state.analytics.isSegmentAnalyticsReady;

Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(Croppa);
Vue.use(VueCropper);
Vue.use(VueMomentJS, moment);
Vue.use(Notifications, { velocity });
Vue.use(VueTruncate);

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
    id: "UA-159867598-2",
    router
});

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
        libraries: "places"
    },
    installComponents: true
});

router.beforeEach(async (to, from, next) => {
    if (auth.getUser() && !store.state.merchants.moduleList) {
        await store.dispatch("merchants/getModuleList");
    }

    if (to.matched.some(record => record.meta.requireAuth)) {
        if (!auth.getUser()) {
            next({
                path: "/login"
            });
        } else if (
            to.matched.some(record => record.meta.requirePermission) ||
            to.matched.some(record => record.meta.validateStep)
        ) {
            if (
                !auth.getHasPasswordUpdated() &&
                to.path != "/account/security"
            ) {
                next({
                    path: "/account/security"
                });
            } else if (
                to.matched.some(record => record.meta.restrictMarketplace)
            ) {
                if (
                    auth.getPlanId() == 5 ||
                    !permission.hasAccess(to.meta.access)
                ) {
                    next({
                        path: "/404"
                    });
                }

                if (
                    isSegmentAnalyticsReady &&
                    to.meta.module &&
                    to.meta.submodule
                ) {
                    window.analytics.page("Submodule Navigation", {
                        module: to.meta.module,
                        submodule: to.meta.submodule,
                        path: to.path
                    });
                }

                next();
            } else {
                if (
                    !permission.hasAccess(to.meta.access) &&
                    to.meta.requirePermission
                ) {
                    next({
                        path: "/404"
                    });
                } else {
                    if (
                        isSegmentAnalyticsReady &&
                        to.meta.module &&
                        to.meta.submodule
                    ) {
                        window.analytics.page("Submodule Navigation", {
                            module: to.meta.module,
                            submodule: to.meta.submodule,
                            path: to.path
                        });
                    }

                    const modulesToTrack = [
                        "store.organization",
                        "store.employee",
                        "estore-products.inventory:topup-estore",
                        "estore-orders.orders:topup-estore",
                        "estore-locations.locations:topup-estore",
                        "estore-promo-codes.vouchers:topup-estore",
                        "estore-settings.settings:topup-estore",
                        "fulfillment.delivery",
                        "fulfillment.pickup",
                        "fulfillment.fees",
                        "fulfillment.settings"
                    ];

                    if (
                        window.smartech &&
                        modulesToTrack.includes(to.meta.access)
                    ) {
                        window.smartech("dispatch", "Page View", {
                            path: to.path
                        });
                    }

                    next();
                }
            }
        } else {
            const topups = auth.getEnabledTopUps();

            if (
                to.meta.access === "vouchers:topup.vouchers:topup-vouchers" &&
                !topups.includes("voucher")
            ) {
                next({
                    path: "/404"
                });
            } else next();
        }
    } else {
        if (!auth.getUser()) {
            auth.logoutNoUser(); // To flush local storage values
            next();
        } else
            next({
                path: "/"
            });
    }
});

const eventsHub = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");

// const idleTime = parseInt((process.env.VUE_APP_IDLE_TIME == null ? 3600000 : process.env.VUE_APP_IDLE_TIME)) + 60000;
// console.log(idleTime);
// Vue.use(IdleVue, {
//     eventEmitter: eventsHub,
//     store,
//     idleTime: idleTime, // 60 seconds
//     startAtIdle: false,
//     keepTracking: auth.getUser()
// });
